import {StorageDAO} from './../DAO/StorageDAO';
import {toCamel} from './../Util/SnakeCamelUtil';
import {BaseService} from './BaseService';
import {AppSingletonUtil} from '../Util/AppSingletonUtil';
import {AuthDAO} from '../DAO/AuthDAO';


/**
 * AuthService
 *
 * ログイン認証関係のロジックサービス
 * DAOで取得したデータを操作等行い、View側に渡す。
 */
export class AuthService extends BaseService {


	/**
	 * login
	 * メールアドレス/パスワードログイン
	 * @param mail メールアドレス
	 * @param password パスワード
	 * @returns トークン
	 */
	public async login(mail: string, password: string) {

		this.log('----------AuthService login-----------');

		// ログインを行い、トークンを取得してくる
		const authDao = new AuthDAO(this as BaseService);
		const ret = await authDao.login(mail, password);
		const dist: any = toCamel(ret);

		// トークンの保存
		AppSingletonUtil.setToken(dist.t);
		const storageDao = new StorageDAO(this as BaseService);
		await storageDao.saveItem('t', dist.t);

		this.log(dist);

		return toCamel(dist);

	}

	/**
	 * lineLoginRecordAuth
	 * 認可リクエストを記録
	 */
	public async getConfigForClient() {
		const authDao = new AuthDAO(this as BaseService);
		return authDao.getConfigForClient();
	}

	/**
	 * lineLoginRecordAuth
	 * 認可リクエストを記録
	 */
	public async lineLoginRecordAuth(loginUrl: string, stateString: string, nonceString: string) {
		this.log('----------AuthService lineLoginRecordAuth-----------');
		const authDao = new AuthDAO(this as BaseService);
		return authDao.lineLoginRecordAuth(loginUrl, stateString, nonceString);
	}

	/**
	 * lineLoginRecordAuthCallBack
	 * 認可コールバックを記録
	 */
	public async lineLoginRecordAuthCallBack(loginUrl: string, authCode: string, stateString: string, errorCode: string, errorDescription: string) {
		this.log('----------AuthService lineLoginRecordAuthCallBack-----------');
		const authDao = new AuthDAO(this as BaseService);
		return authDao.lineLoginRecordAuthCallBack(loginUrl, authCode, stateString, errorCode, errorDescription);
	}

	/**
	 * lineLogin
	 *
	 * Lineにユーザー情報の取得を依頼する
	 * @returns トークン
	 */
	public async lineLogin(authCode: string, nonceString: string, token: string) {

		this.log('----------AuthService lineLogin-----------');

		// ログインを行い、トークンを取得してくる
		const authDao = new AuthDAO(this as BaseService);
		const ret = await authDao.lineLogin(authCode, nonceString, token);
		const dist: any = toCamel(ret);

		// トークンが生成されていれば、シングルトンで保持する。
		if (dist.user) {
			AppSingletonUtil.setToken(dist.user.t);
			const storageDao = new StorageDAO(this as BaseService);
			await storageDao.saveItem('t', dist.user.t);
		}
		return toCamel(dist);
	}

	/**
	 * sendForgetPassword
	 * パスワード忘れメール送信
	 * @param mail メールアドレス
	 */
	public async sendForgetPassword(mail: string, birthday: any) {

		this.log('----------AuthService sendForgetPassword-----------');

		// パスワード忘れのメールを送信する
		const authDao = new AuthDAO(this as BaseService);
		const ret = await authDao.sendForgetPassword(mail, birthday);

		return ret;

	}

	/**
	 * sendForgetPasswordInLogin
	 * パスワード忘れメール送信
	 * @param birthday 生年月日
	 */
	public async sendForgetPasswordInLogin(birthday: string) {

		this.log('----------AuthService sendForgetPasswordInLogin-----------');

		// パスワード忘れのメールを送信する
		const authDao = new AuthDAO(this as BaseService);
		const ret = await authDao.sendForgetPasswordInLogin(birthday);

		return ret;


	}

	/**
	 * resettingPassword
	 * パスワード再設定
	 * @param onetimeToken リセットトークン
	 * @param password パスワード
	 * @returns 成功可否
	 */
	public async resettingPassword(onetimeToken: string, password: string) {

		this.log('----------AuthService resettingPassword-----------');

		// 新しいパスワードを送信する
		const authDao = new AuthDAO(this as BaseService);
		const ret = await authDao.resettingPassword(onetimeToken, password);

		return ret;


	}


	/**
	 * changeUserPassword
	 * パスワード変更
	 * @param oldPass 現在のパスワード
	 * @param newPass 新しいパスワード
	 * @returns ユーザー情報
	 */
	public async changeUserPassword(oldPass: string, newPass: string) {

		this.log('----------AuthService changeUserPassword-----------');

		// 新しいパスワードを送信する
		const authDao = new AuthDAO(this as BaseService);
		const ret = await authDao.changeUserPassword(oldPass, newPass);

		return ret;


	}

	/**
	 * createPassword
	 * @param password
	 */
	public async createPassword(password: string) {

		// 新しいパスワードを送信する
		const authDao = new AuthDAO(this as BaseService);
		const ret = await authDao.createPassword(password);

		return ret;

	}

	/**
	 * パスワードの存在チェック
	 */
	public async isExistPassword() {

		// 新しいパスワードを送信する
		const authDao = new AuthDAO(this as BaseService);
		const ret = await authDao.isExistPassword();
		const dist: any = toCamel(ret);

		return dist.exist;

	}


}
